import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Button, Container, Typography, FormControlLabel, Switch } from '@material-ui/core';
import AppCtx from '../contexts/app_context';
import { HOME } from '../private/routes';
import { Redirect } from 'react-router-dom';
import debug from '../utils/debugging'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary,
		height: 200,
		backgroundColor: 'lightgray',
	},
	paperDark: {
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary,
		height: 200,
		backgroundColor: 'gray',
	},
	gridItemWithMargin: {
		marginLeft: theme.spacing(2),
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary,
		height: 200,
		backgroundColor: 'lightgray',
	},
	userData: {
		textAlign: 'center',
	},

}));
export default function UserProfile() {
	const classes = useStyles();
	const { user, signOutUser, setAutoPlayAudio } = React.useContext(AppCtx)
	const [redirect, setRedirect] = React.useState(false)

	const handleSignOut = () => {
		signOutUser()
		setRedirect(true)
	}

	const handleSwitchClick = (e) => {
		// const {name, value}
		debug.log(e.target)
		debug.log(e.target.checked)
		setAutoPlayAudio(e.target.checked)
	}

	// handle redirects 
	// TODO: using the redirect component will not work here, either change
	// the way we redirect, (change the actually URL before render) or bubble
	// this redirect path to the private route that is the parent of this component
	if (redirect) {
		return <Redirect to={HOME} />
	}

	return <div className={classes.root}>
		<Container component="main" maxWidth="sm" >
			<br />
			<div className={classes.userData}>
				<Grid container spacing={3} alignContent='center'>
					<Grid item xs={12} md={4} >
					</Grid>
					<Grid item xs={12} md={8} >
						<Typography variant='h4' component='h2'>
							{user.agent_name}
						</Typography>
					</Grid>
					<br />
				</Grid>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<Typography align='right' variant='body1'>
							<strong>Age:</strong>
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography align='left' variant='body1'>
							{user.age}
						</Typography>
					</Grid>
					<Grid item xs={6} >
						<Typography align='right' variant='body1'>
							<strong>Allegiance:</strong>
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography align='left' variant='body1'>
							{user.allegiance}
						</Typography>
					</Grid>
				</Grid>
			</div>
			<br />
			<br />
			<br />
			<Typography variant='h5' component='h5'>Settings</Typography>
			<Container maxWidth="sm">
				<FormControlLabel
					value="end"
					control={<Switch
						color="primary"
						checked={user.auto_play_audio || false}
						onClick={handleSwitchClick} />}
					label="Play Audio Automaticly"
					labelPlacement="end"
					name='audio_auto_play'
				/>
			</Container>
		</Container>
		<br />
		<br />
		<br />
		<Container>
			<Grid container direction="row-reverse">
				<Grid item>
					<Button onClick={handleSignOut} color='primary'>Sign out</Button>
				</Grid>
			</Grid>
		</Container>
	</div>
}

